module.exports = __webpack_public_path__ + "img/justsubmit-3.c9cb08d9.png";